<template>
    <Dialog
        :value="true"
        :header-text="$t('Change')"
        :width="450"
        persistent
        hide-close-icon
        fixed
        @close_modal="$emit('close')"
    >
        <div style="max-width: 200px">
            <text-field
                :value="formattedBalance"
                :label="$t('Period balance')"
                :error-messages="error"
                @blur="setBalance"
                @input="formattedBalance = $event"
            />
        </div>
        <template slot="footer">
            <danger-button
                v-if="flextimeId"
                @click="onClear"
            >
                {{ $t("Reset balance") }}
            </danger-button>
            <v-spacer />
            <secondary-button @click="$emit('close')">
                {{ $t('Cancel') }}
            </secondary-button>
            <primary-button
                :loading="loader.isLoading"
                @click="onSave"
            >
                {{ $t('Save') }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import { computed, ref, watch, reactive } from "@vue/composition-api";
import Dialog from "@/components/Dialog";
import ApiFlexTime from "@/api/report/flextime";
import {formatTimeDuration, parseTimeDuration} from "@/plugins/formatting";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import Loader from "@/utility/loader";

export default {
    name: "ReportChangeFlextimeBalanceModal",
    components: {
        Dialog
    },
    props: {
        balance: {
            type: Number,
            required: true
        },
        flextimeId: {
            type: Number,
            default: null
        }
    },
    setup(props, ctx) {
        const localBalance = ref(props.balance);
        let formattedBalance = ref("");
        const loader = reactive(new Loader());
        const error = ref(null);

        const updateFormattedBalance = async () => {
            let output = formatTimeDuration(localBalance.value, "0:00:00");
            if (localBalance.value >= 0) {
                output = "+ " + output
            }

            formattedBalance.value = output
        }

        updateFormattedBalance()

        const setBalance = (event) => {
            let value = event.target.value
            value = value.trim()

            let isPositive = true

            if (value[0] === '-') {
                isPositive = false
            }

            let timeValue = value.replace('-', '').replace('+', '').replace(' ', '').trim();
            if (timeValue === '') {
                localBalance.value = 0
                updateFormattedBalance()
                error.value = null
                return
            }

            timeValue = parseTimeDuration(timeValue);

            if (isNaN(timeValue) || timeValue === null) {
                error.value = $t('Invalid format')
                return
            }

            error.value = null

            if (!isPositive) {
                timeValue = -timeValue
            }

            localBalance.value = timeValue
            updateFormattedBalance()
        }

        const onSave = async () => {
            if (error.value) {
                return
            }

            ctx.emit('update-balance', localBalance.value)
            ctx.emit('close')
        }

        const onClear = () => {
            ctx.emit('close')
            ctx.emit('clear')
        }

        return {
            localBalance,
            formattedBalance,
            setBalance,
            onSave,
            loader,
            error,
            onClear
        }
    }
}
</script>
